import "../assets/Checkbox.css";
import { defineComponent as v, ref as c, openBlock as g, createElementBlock as x, withModifiers as y, unref as n, createVNode as B, createElementVNode as f } from "vue";
import { d as C } from "./debounce.BDLEW31m.js";
import { _ as w } from "./Tooltip.vue_vue_type_style_index_0_lang.CQgCKEVm.js";
const V = ["checked", "disabled"], E = ["id"], N = /* @__PURE__ */ v({
  __name: "Checkbox",
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    checked: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(d, { expose: p, emit: m }) {
    const t = d, k = m, s = c(), e = c(t.checked), a = c();
    function h() {
      a.value.hide();
    }
    const i = C(() => {
      e.value = !e.value, h(), k("update:modelValue", e.value);
    }, 200, { leading: !0, trailing: !1 });
    function _() {
      var u;
      const {
        top: l,
        left: o,
        width: r
      } = ((u = s.value) == null ? void 0 : u.getBoundingClientRect()) || {};
      a.value.show(t.errorMessage, {
        top: l,
        left: o + r / 2
      });
    }
    function b() {
      const l = !t.required || !!e.value;
      return l || _(), l;
    }
    return p({
      validate: b,
      isChecked: e,
      id: t.id
    }), (l, o) => (g(), x("div", {
      class: "tool--checkbox",
      onMousedown: o[0] || (o[0] = y(
        //@ts-ignore
        (...r) => n(i) && n(i)(...r),
        ["left"]
      )),
      onClick: o[1] || (o[1] = //@ts-ignore
      (...r) => n(i) && n(i)(...r)),
      checked: e.value,
      disabled: d.disabled
    }, [
      B(w, {
        ref_key: "errorTooltipRef",
        ref: a,
        "auto-hide": 3e3
      }, null, 512),
      f("input", {
        id: t.id,
        class: "tool--checkbox__input",
        type: "checkbox"
      }, null, 8, E),
      f("span", {
        class: "tool--checkbox__checkmark",
        ref_key: "checkmarkDom",
        ref: s
      }, null, 512)
    ], 40, V));
  }
});
export {
  N as _
};
//# sourceMappingURL=Checkbox.vue_vue_type_style_index_0_lang.DRHsf1oJ.js.map
